export default __webpack_public_path__ + "static/media/CAPTURE_CODE.4c2ef9da.jpg";